import { render, staticRenderFns } from "./ResourcesHeader.vue?vue&type=template&id=272d225b&"
import script from "./ResourcesHeader.vue?vue&type=script&lang=js&"
export * from "./ResourcesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports